'use client';

import { SECTION_VIEW_TRACKING } from '@/types/constants';

export const scrollToMapSection = () => {
	const mapSection = document.getElementById(SECTION_VIEW_TRACKING.MAP_VIEW_SECTION);

	mapSection?.scrollIntoView();
};
